import apiClient from './client';

export type TermAndConditionsContentItem = {
  title: string;
  items: string[];
};

export type TermAndConditionsPayload = {
  title: string;
  description: string;
  content: TermAndConditionsContentItem[];
};

export type TermAndConditionsResponse = TermAndConditionsPayload & {
  id: number | null;
  updatedAt?: string | null;
};

export interface MessageResponse {
  message: string;
  data?: TermAndConditionsResponse;
}

export const termAndConditionsApi = {
  get: async (): Promise<TermAndConditionsResponse> => {
    const response = await apiClient.get('/api/term-and-conditions');
    return response.data;
  },

  create: async (data: TermAndConditionsPayload): Promise<MessageResponse> => {
    const response = await apiClient.post('/api/term-and-conditions', data);
    return response.data;
  },

  update: async (data: TermAndConditionsPayload): Promise<MessageResponse> => {
    const response = await apiClient.put('/api/term-and-conditions', data);
    return response.data;
  },

  delete: async (): Promise<MessageResponse> => {
    const response = await apiClient.delete('/api/term-and-conditions');
    return response.data;
  },
};